import { SavedScenario, User } from '../types';

const STORAGE_KEY = 'optimize-meet-scenarios';

/**
 * Save a scenario to localStorage
 */
export function saveScenario(
  name: string,
  users: User[],
  destination: string
): SavedScenario {
  const scenarios = getScenarios();
  const scenario: SavedScenario = {
    id: `scenario-${Date.now()}`,
    name,
    users,
    destination,
    createdAt: new Date().toISOString(),
  };
  scenarios.push(scenario);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(scenarios));
  return scenario;
}

/**
 * Get all saved scenarios
 */
export function getScenarios(): SavedScenario[] {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

/**
 * Delete a saved scenario
 */
export function deleteScenario(id: string): void {
  const scenarios = getScenarios().filter(s => s.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(scenarios));
}
